<table class="table sort-table">
    <thead>
        <tr>
            <th class="text-center sortable-list-header" *ngIf="model.options.showCheckboxes"></th>
            <th *ngFor="let column of model.options.columns" class="text-center sortable sortable-list-header">
                <a (click)="doSort(column.field)"> {{ column.title }} </a>

                <fa-icon
                    *ngIf="reverseSort && orderByField === column.field && model.rows.length > 0"
                    [icon]="faSortDown"
                ></fa-icon>

                <fa-icon
                    *ngIf="!reverseSort && orderByField === column.field && model.rows.length > 0"
                    [icon]="faSortUp"
                ></fa-icon>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngIf="model.rows.length === 0">
            <td
                [colSpan]="model.options.columns.length"
                class="text-center"
                translate="SORTABLE_LIST_EMPTY_TEXT_PLACEHOLDER"
            ></td>
        </tr>
        <ng-container *ngIf="model.rows.length > 0">
            <tr
                *ngFor="let row of model.rows | orderBy: orderByField : reverseSort"
                [ngClass]="
                    row === model.selectedRow && model.options.highlightSelectedRow
                        ? 'selected'
                        : row.rowValueInvalid
                          ? 'row-invalid'
                          : ''
                "
            >
                <td *ngIf="model.options.showCheckboxes">
                    <pace-core-checkbox-input [(model)]="row.isRowSelected"></pace-core-checkbox-input>
                </td>
                <td *ngFor="let column of model.options.columns" (click)="rowClick(row)" class="text-center">
                    {{ get(row, column.field) }}
                </td>
            </tr>
        </ng-container>
    </tbody>
</table>
